import React, { Component } from "react"
import style from "./style.css"
import * as strings from "../../strings"
import Pagination from "react-js-pagination"
import IconButton from "react-toolbox/lib/button/IconButton"
import _ from "lodash"

type Value = { [string]: string }
type Column = {
  title: string,
  key: string,
  transform?: ( string, string, Value ) => string,
}

export default class BigList extends Component {
  defaultProps: {
    columns: [],
    items: [],
  }

  props: {
    columns: Column[],
    loadMore: () => {},
    hasMoreItems: () => boolean,
    items: Value[],
    renderItems?: ( Column[], Value[] ) => mixed,
    renderHeader?: ( Column[] ) => mixed,
    itemsPerPage: any,
    activePage: any,
    handlePageChange: () => any,
    totalItems: any,
    enablePagination: boolean,
    snakeEnabled: boolean,
    onDelete: () => {},
    onModify: () => {},
    columnPadding: ?number,
  }

  getColumns = () => this.props.columns || []
  getItems = () => this.props.items || []

  renderActions = ( item, i ) => {
    const { onDelete, onModify } = this.props

    return (
      <div className={style.actionToolbar}>
        { onDelete ? <IconButton
          className={style.bigListButton}
          icon="delete"
          ripple={false}
          onClick={() => onDelete( item, i )}
        /> : null }

        { onModify ? <IconButton
          className={style.bigListButton}
          icon="edit"
          ripple={false}
          onClick={() => onModify( item, i )}
        /> : null }
      </div>
    )
  }

  // TODO: This function is too monolithic, try to move the columns render method into a
  // separate function
  renderItems = ( columns, items, iconPercentage, nonIconWidth, columnPadding ) => {
    return (
      <div className={style.items}>
        {items.map( ( item, i ) => (
          <div key={i} className={style.itemWrapper}
            style={{ cursor: item._onClick ? "pointer" : "initial" }}>
            {columns.map( ( column, index ) => {
              return [
                ( columnPadding ? <div style={{ width: columnPadding + "px" }} /> : null ),
                <div
                  style={{
                    width: ( !column.key.startsWith( "icon" ) ? nonIconWidth : iconPercentage ) + "%",
                    display: "flex",
                    alignItems: "center",
                  }}
                  key={column.key || index}
                  onClick={ !column.key.startsWith( "icon" ) ? item._onClick : undefined}
                >
                  {
                    column.transform( _.get( item, column.key ), column.key, item ) || "--"
                  }
                </div>,
              ] } )}
            {this.renderActions( item, i )}
          </div>
        ) )}
      </div>
    )
  }

  getWidth = ( iconPercentage ) => {
    const columns = this.getColumns()
    let totalPercentage = 100
    let columnsToDivide = columns.length
    columns.forEach( column => {
      if ( column.key.startsWith( "icon" ) ) {
        totalPercentage = totalPercentage - iconPercentage
        columnsToDivide = columnsToDivide - 1
      }
    } )
    return totalPercentage / columnsToDivide
  }

  renderHeader ( columns, iconPercentage, nonIconWidth, columnPadding ) {
    return (
      <div className={style.header}>
        {columns.map( ( column, index ) => [
          ( columnPadding ? <div style={{ width: columnPadding + "px" }} /> : null ),
          <div
            key={column.key || index}
            className={style.column}
            style={{ width: ( !column.key.startsWith( "icon" ) ? nonIconWidth : iconPercentage ) + "%" }}
          >
            {column.title}
          </div>,
        ] )}
      </div>
    )
  }

  loader () {
    return ( <div className={style.loader}>{strings.generalStrings.loading}</div> )
  }

  render () {
    const { columnPadding } = this.props
    const iconPercentage = 3
    const nonIconWidth = this.getWidth( iconPercentage )

    // This applies a default transform function in the case the user doesen't
    // provide it. By default we use the unity function which does nothing.
    const columns = this.getColumns().map( col => col.transform ? col : {
      ...col,
      transform: x => x,
    } )
    const items = this.getItems()

    const itemRenderFn = this.props.renderItems || this.renderItems
    const headerRenderFn = this.props.renderHeader || this.renderHeader
    return (
      <div className={ this.props.snakeEnabled ? style.snakeRoot : style.root}>
        {headerRenderFn( columns, iconPercentage, nonIconWidth, columnPadding )}
        {itemRenderFn( columns, items, iconPercentage, nonIconWidth, columnPadding )}
        { this.props.enablePagination ?
          <div className={style.paginationCss}>
            <Pagination
              innerClass={style.ulClass}
              activeClass={style.activeClass}
              prevPageText={strings.generalStrings.previous}
              nextPageText={strings.generalStrings.next}
              firstPageText={strings.generalStrings.first}
              lastPageText={strings.generalStrings.lastOne}
              activePage={this.props.activePage}
              itemsCountPerPage={this.props.itemsPerPage}
              totalItemsCount={this.props.totalItems}
              onChange={this.props.handlePageChange}
            /> </div>
          : <div/>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BigList/index.jsx